/*
 * BIOSHOTS BUYBOX v1.0
 * Nieuw compact aankoopdesign (MINIMAL-v2), gebouwd op de bewezen
 * checkout/selling-plan logica van bioshots-plan-cards.js v5.4.
 *
 * Identiek aan v5.4:
 * - Variant + selling plan worden op het thema-formulier gezet (setVariant / setSellingPlanOnForms / checkPlanRadio)
 * - Checkout leest variant + selling plan uit het formulier (FormData)
 * - bi-monthly sessionStorage tracking (window.biMonthlyVariants + bioshots_bimonthly_variants)
 * - Cadeau-logica: shotglaasje altijd 1x gratis (_gift), scoop alleen bij 2-maands abo (_gift)
 * - Prijzen dynamisch uit selling plan radios (data-variant-price-cents)
 * - Event: bioshots:plan-selected
 * - Thema koopknop intercept (setupCartIntegration)
 *
 * Nieuw:
 * - Steppers: extra shotglaasjes/scoops bijkopen (zonder _gift property)
 * - window.bsBuyboxApi voor sticky sync
 */

console.log('✅ bioshots-buybox.js v1.0 loaded at:', new Date().toLocaleTimeString());

(function() {
  // Gratis cadeaus en betaalde extra's zijn APARTE producten/varianten
  const VARIANTS = {
    glass: { paid: '51581178347862', gift: '51556485562710' },
    scoop: { paid: '51581262496086', gift: '51557504811350' }
  };
  const SHOTGLASS_VARIANT_ID = VARIANTS.glass.gift;
  const SCOOP_VARIANT_ID = VARIANTS.scoop.gift;

  function qs(r, s) { return (r || document).querySelector(s); }
  function qsa(r, s) { return Array.from((r || document).querySelectorAll(s)); }

  function getSectionEl(container) {
    const sectionId = container.getAttribute('data-section-id');
    return document.querySelector(`#shopify-section-${sectionId}`) || container.closest('[id^="shopify-section-"]') || document;
  }

  function getForms(sectionEl) {
    return qsa(sectionEl, '[action*="/cart/add"]');
  }

  function getVariantInput(forms, sectionEl) {
    if (!forms || !forms.length) return null;
    for (const f of forms) {
      try {
        if (sectionEl && sectionEl.contains(f) && f.querySelector('input[name="selling_plan"]'))
          return f.querySelector('select[name="id"], input[name="id"]');
      } catch (e) {}
    }
    for (const f of forms) {
      try {
        if (sectionEl && sectionEl.contains(f))
          return f.querySelector('select[name="id"], input[name="id"]');
      } catch (e) {}
    }
    return null;
  }

  function setVariant(variantInput, id) {
    if (!variantInput) return;
    try {
      const tag = variantInput.tagName.toLowerCase();
      variantInput.value = id;
      variantInput.dispatchEvent(new Event(tag === 'select' ? 'change' : 'input', { bubbles: true }));
      if (tag !== 'select') variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {}
  }

  function setSellingPlanOnForms(sectionEl, spId) {
    const forms = getForms(sectionEl);
    const targetForm = (forms || []).find(f => sectionEl && sectionEl.contains(f)) || forms[0];
    if (!targetForm) return;

    try {
      Array.from(targetForm.querySelectorAll('input[name="selling_plan"]')).forEach(inp => {
        if (!inp.value || String(inp.value).trim() === '') inp.parentNode?.removeChild(inp);
      });
    } catch(e){}

    let inp = targetForm.querySelector('input[name="selling_plan"]');
    if (!inp) { inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'selling_plan'; targetForm.appendChild(inp); }
    inp.value = spId || '';

    let inp2 = targetForm.querySelector('input[name="selling_plan_id"]');
    if (!inp2) { inp2 = document.createElement('input'); inp2.type = 'hidden'; inp2.name = 'selling_plan_id'; targetForm.appendChild(inp2); }
    inp2.value = spId || '';
  }

  function allocationRadios(sectionEl, variantId) {
    const section = qs(sectionEl, `section[data-variant-id="${variantId}"]`);
    if (!section) return [];
    return qsa(section, 'input[type="radio"][data-radio-type="selling_plan"]');
  }

  function oneTimeRadio(sectionEl, variantId) {
    return qs(sectionEl, `section[data-variant-id="${variantId}"] input[type="radio"][data-radio-type="one_time_purchase"]`);
  }

  function parseCfg(container) {
    try { return JSON.parse(qs(container, '.bs-buybox-json').textContent); }
    catch (e) { return { ids:{}, labels:{monthly:[],biMonthly:[]}, nativeSellingPlanIds:[], variants:{}, gifts:{}, texts:{} }; }
  }

  function pickPlanId(radios, cadence, cfg) {
    if (!radios || radios.length === 0) return null;
    const configKey = cadence === 'bi-monthly' ? 'biMonthly' : cadence;
    const direct = cfg?.ids?.[configKey];
    if (direct) return String(direct);

    const nativeSet = new Set((cfg?.nativeSellingPlanIds) || []);
    const labels = cadence === 'monthly' ? (cfg.labels?.monthly || []) : (cfg.labels?.biMonthly || []);

    const found = radios.find(r => {
      const spNumeric = String(r.dataset?.sellingPlanId || r.value || r.getAttribute('data-selling-plan-id') || '').trim();
      if (!spNumeric) return false;
      if (nativeSet.size > 0 && !nativeSet.has(spNumeric) && !nativeSet.has(`gid://shopify/SellingPlan/${spNumeric}`)) return false;
      const label = ((r.getAttribute('aria-label') || '') + ' ' + (r.nextElementSibling?.textContent || '')).toLowerCase();
      if (labels.length > 0) return labels.some(k => label.replace(/-/g,' ').includes(String(k).toLowerCase().replace(/-/g,' ')));
      return true;
    });

    if (!found) return null;
    return String(found.dataset?.sellingPlanId || found.value || found.getAttribute('data-selling-plan-id') || '');
  }

  function checkPlanRadio(sectionEl, variantId, type, spId) {
    const base = qs(sectionEl, `section[data-variant-id="${variantId}"]`);
    if (!base) return;
    const radio = type === 'onetime'
      ? qs(base, 'input[type="radio"][data-radio-type="one_time_purchase"]')
      : qs(base, `input[type="radio"][data-radio-type="selling_plan"][data-selling-plan-id="${spId}"]`);
    if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  function getCentsFromRadio(r, key) {
    if (!r) return null;
    const dv = r?.dataset?.[key];
    if (dv && !isNaN(Number(dv))) return Number(dv);
    const av = r.getAttribute(`data-${key.replace(/([A-Z])/g,'-$1').toLowerCase()}`);
    if (av && !isNaN(Number(av))) return Number(av);
    if (key === 'variantPriceCents') {
      const fp = r.dataset?.variantPrice || r.getAttribute('data-variant-price');
      if (fp) {
        const m = fp.match(/[\d,]+/);
        if (m) { const c = Math.round(parseFloat(m[0].replace(',','.')) * 100); if (!isNaN(c)) return c; }
      }
    }
    return null;
  }

  function formatMoneyEUR(cents) {
    if (cents == null) return '';
    try { return (cents/100).toLocaleString('nl-NL',{style:'currency',currency:'EUR'}); }
    catch(e) { return '€' + (cents/100).toFixed(2).replace('.',','); }
  }

  // ---- CHECKOUT (identiek aan v5.4, uitgebreid met betaalde extra's) ----
  async function handleCheckoutWithGifts(sectionEl, planType, cadence, submitButton, extras) {
    const forms = getForms(sectionEl);
    const targetForm = (forms || []).find(f => sectionEl && sectionEl.contains(f)) || forms[0];
    if (!targetForm) return;

    const labelEl = submitButton ? submitButton.querySelector('.bs-buy-label, .bs-sticky__btn-label') : null;
    const loadEl  = submitButton ? submitButton.querySelector('.bs-buy-loading, .bs-sticky__btn-loading') : null;
    if (labelEl) labelEl.style.display = 'none';
    if (loadEl)  loadEl.style.display = 'flex';
    if (submitButton) submitButton.disabled = true;

    try {
      const formData = new FormData(targetForm);
      const variantId   = formData.get('id');
      const quantity    = parseInt(formData.get('quantity')) || 1;
      const sellingPlan = formData.get('selling_plan');

      if (!variantId) throw new Error('No variant ID found in form');
      if (planType === 'subscription' && !sellingPlan) throw new Error('Subscription selected but no selling plan ID found');

      if (planType === 'subscription' && cadence === 'bi-monthly') {
        window.biMonthlyVariants = window.biMonthlyVariants || [];
        if (!window.biMonthlyVariants.includes(variantId)) window.biMonthlyVariants.push(variantId);
        try {
          const saved = sessionStorage.getItem('bioshots_bimonthly_variants');
          const variants = saved ? JSON.parse(saved) : [];
          if (!variants.includes(variantId)) { variants.push(variantId); sessionStorage.setItem('bioshots_bimonthly_variants', JSON.stringify(variants)); }
        } catch(e) {}
      }

      const mainBody = { id: variantId, quantity };
      if (sellingPlan) mainBody.selling_plan = sellingPlan;

      const mainRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(mainBody)
      });
      if (!mainRes.ok) throw new Error('Failed to add main product: ' + await mainRes.text());

      await new Promise(r => setTimeout(r, 400));

      const cart = await fetch('/cart.js').then(r => r.json());
      const hasShotglass = cart.items.some(i => String(i.variant_id) === SHOTGLASS_VARIANT_ID);
      const hasScoop     = cart.items.some(i => String(i.variant_id) === SCOOP_VARIANT_ID);

      if (!hasShotglass) {
        await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: SHOTGLASS_VARIANT_ID, quantity:1, properties:{'_gift':'Gratis cadeau','_parent_variant':variantId} }) });
        await new Promise(r => setTimeout(r, 300));
      }

      if (planType === 'subscription' && cadence === 'bi-monthly' && !hasScoop) {
        await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: SCOOP_VARIANT_ID, quantity:1, properties:{'_gift':'Extra gratis bij 2-maands abonnement','_parent_variant':variantId} }) });
        await new Promise(r => setTimeout(r, 300));
      }

      // ---- NIEUW: betaalde extra's uit de steppers (aparte betaalde varianten, zonder _gift) ----
      if (extras && extras.glass > 0) {
        await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: VARIANTS.glass.paid, quantity: extras.glass }) });
        await new Promise(r => setTimeout(r, 300));
      }
      if (extras && extras.scoop > 0) {
        await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id: VARIANTS.scoop.paid, quantity: extras.scoop }) });
        await new Promise(r => setTimeout(r, 300));
      }

      await new Promise(r => setTimeout(r, 300));
      window.location.href = '/cart';

    } catch (error) {
      console.error('❌ Checkout error:', error);
      if (labelEl) labelEl.style.display = '';
      if (loadEl)  loadEl.style.display = 'none';
      if (submitButton) submitButton.disabled = false;
      alert('Er ging iets mis. Probeer het opnieuw: ' + error.message);
    }
  }

  function initBuybox() {
    qsa(document, '.bs-buybox').forEach(container => {
      const sectionEl = getSectionEl(container);
      if (!sectionEl) return;

      const forms = getForms(sectionEl);
      const variantInput = getVariantInput(forms, sectionEl);
      const cfg = parseCfg(container);

      // ---- STATE ----
      let mode = 'once';   // 'once' | 'sub'
      let freq = 'b';      // 'b' (bi-monthly) | 'm' (monthly)
      // Alleen bewust bijgekochte extra's zijn state; gratis exemplaren volgen uit mode/freq.
      // Zo verdwijnt de gratis scoop-teller automatisch bij switch abo -> eenmalig.
      let extra = { glass: 0, scoop: 0 };

      const GIFT_PRICES = cfg.gifts?.prices || { glass: 495, scoop: 995 };

      function planTypeCadence() {
        if (mode === 'once') return { planType: 'onetime', cadence: null, variantId: cfg.variants.oneTime };
        if (freq === 'b')    return { planType: 'subscription', cadence: 'bi-monthly', variantId: cfg.variants.biMonthly };
        return { planType: 'subscription', cadence: 'monthly', variantId: cfg.variants.monthly };
      }

      function free(i) {
        if (i === 'glass') return 1;
        if (i === 'scoop') return (mode === 'sub' && freq === 'b') ? 1 : 0;
        return 0;
      }

      // ---- FORM SYNC (identiek patroon aan card click in v5.4) ----
      function syncForm() {
        const { planType, cadence, variantId } = planTypeCadence();
        setVariant(variantInput, variantId);
        setTimeout(() => {
          if (planType === 'subscription') {
            const spId = pickPlanId(allocationRadios(sectionEl, variantId), cadence, cfg);
            setSellingPlanOnForms(sectionEl, spId);
            checkPlanRadio(sectionEl, variantId, 'subscription', spId);
          } else {
            setSellingPlanOnForms(sectionEl, null);
            checkPlanRadio(sectionEl, variantId, 'onetime', null);
          }
          render();
          document.dispatchEvent(new CustomEvent('bioshots:plan-selected'));
        }, 300);
      }

      // ---- PRIJZEN (uit radios, zoals priceData* in v5.4) ----
      function onceData() {
        const r = oneTimeRadio(sectionEl, cfg.variants.oneTime);
        return {
          priceCents: getCentsFromRadio(r, 'variantPriceCents'),
          compareCents: getCentsFromRadio(r, 'variantCompareAtPriceCents')
        };
      }

      function subData(f) {
        const cadence = f === 'b' ? 'bi-monthly' : 'monthly';
        const variantId = f === 'b' ? cfg.variants.biMonthly : cfg.variants.monthly;
        const radios = allocationRadios(sectionEl, variantId);
        const spId = pickPlanId(radios, cadence, cfg);
        if (!spId) return { priceCents: null };
        const r = qs(sectionEl, `section[data-variant-id="${variantId}"] input[type="radio"][data-radio-type="selling_plan"][data-selling-plan-id="${spId}"]`);
        return { priceCents: getCentsFromRadio(r, 'variantPriceCents') };
      }

      // ---- UI ----
      function setMode(m) {
        mode = m;
        qs(container, '#bs-o-once').classList.toggle('on', m === 'once');
        qs(container, '#bs-o-sub').classList.toggle('on', m === 'sub');
        qs(container, '#bs-e-once').classList.toggle('open', m === 'once');
        qs(container, '#bs-e-sub').classList.toggle('open', m === 'sub');
        syncForm();
      }

      function setFreq(f) { freq = f; syncForm(); }

      function bump(i, d) {
        const maxExtra = 9 - free(i);
        extra[i] = Math.max(0, Math.min(maxExtra, extra[i] + d));
        render();
      }

      qs(container, '#bs-line-sub').addEventListener('click', () => setMode('sub'));
      qs(container, '#bs-line-once').addEventListener('click', () => setMode('once'));
      qs(container, '#bs-freq').addEventListener('change', function() { setFreq(this.value); });

      container.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-bump]');
        if (!btn || btn.disabled) return;
        const parts = btn.dataset.bump.split(':');
        bump(parts[0], parseInt(parts[1]));
      });

      // ---- RENDER ----
      function render() {
        // cadeau-rijen: n = gratis + bewust gekozen extra's
        ['glass','scoop'].forEach(i => {
          const f = free(i), paid = extra[i], n = f + paid, p = GIFT_PRICES[i];

          const gt = qs(container, '#bs-gt-' + i);
          if (gt) gt.style.display = f > 0 ? 'inline-block' : 'none';
          const row = qs(container, '#bs-row-' + i);
          if (row) row.classList.toggle('gift', f > 0);

          let txt;
          if (f > 0 && paid === 0) {
            txt = `<span class="g">1× gratis inbegrepen</span><br>Wil je er meer? ${formatMoneyEUR(p)} per extra stuk`;
          } else if (f > 0 && paid > 0) {
            txt = `<span class="g">1× gratis</span> + ${paid} extra à ${formatMoneyEUR(p)} = <span class="t">${formatMoneyEUR(paid*p)}</span>`;
          } else if (n === 0) {
            txt = `${formatMoneyEUR(p)} per stuk · nog niet toegevoegd`;
          } else if (n === 1) {
            txt = `1 × ${formatMoneyEUR(p)} = <span class="t">${formatMoneyEUR(p)}</span>`;
          } else {
            txt = `${n} × ${formatMoneyEUR(p)} = <span class="t">${formatMoneyEUR(n*p)}</span>`;
          }
          const pEl = qs(container, '#bs-p-' + i);
          if (pEl) pEl.innerHTML = txt;

          const cEl = qs(container, '#bs-c-' + i);
          if (cEl) cEl.innerHTML =
            `<div class="bs-stp">
              <button type="button" data-bump="${i}:-1" ${paid<=0?'disabled':''}>−</button>
              <span class="n">${n}</span>
              <button type="button" data-bump="${i}:1" ${n>=9?'disabled':''}>+</button>
            </div>`;
        });

        // optieprijzen
        const od = onceData();
        const sb = subData('b');
        const sm = subData('m');

        const pOnce = qs(container, '#bs-p-once');
        if (pOnce && od.priceCents != null) pOnce.textContent = formatMoneyEUR(od.priceCents);

        const pw = qs(container, '#bs-pw-sub');
        if (pw && od.priceCents != null) pw.textContent = formatMoneyEUR(od.priceCents);

        const pSub = qs(container, '#bs-p-sub');
        const pmSub = qs(container, '#bs-pm-sub');
        const noteEl = qs(container, '#bs-note-sub');
        if (freq === 'b') {
          if (pSub && sb.priceCents != null) pSub.textContent = formatMoneyEUR(Math.round(sb.priceCents / 2));
          if (pmSub) pmSub.textContent = 'per maand';
          if (noteEl) noteEl.innerHTML = cfg.texts.noteBiMonthly || '';
        } else {
          if (pSub && sm.priceCents != null) pSub.textContent = formatMoneyEUR(sm.priceCents);
          if (pmSub) pmSub.textContent = 'per maand';
          if (noteEl) noteEl.innerHTML = cfg.texts.noteMonthly || '';
        }

        // totaal
        let ex = 0;
        ['glass','scoop'].forEach(i => ex += extra[i] * GIFT_PRICES[i]);

        let base, lab, cta, tr;
        if (mode === 'once') {
          base = (od.priceCents || 0) + (cfg.shippingCents || 0);
          lab = cfg.texts.totalOnce; cta = cfg.texts.ctaOnce; tr = cfg.texts.trustOnce;
        } else if (freq === 'b') {
          base = sb.priceCents || 0;
          lab = cfg.texts.totalSub; cta = cfg.texts.ctaSub; tr = cfg.texts.trustSub;
        } else {
          base = sm.priceCents || 0;
          lab = cfg.texts.totalSub; cta = cfg.texts.ctaSub; tr = cfg.texts.trustSub;
        }

        const tLab = qs(container, '#bs-t-lab');
        const tAmt = qs(container, '#bs-t-amt');
        const buyLabel = qs(container, '.bs-buy-label');
        const tr2 = qs(container, '#bs-tr2-text');
        if (tLab) tLab.textContent = lab || '';
        if (tAmt) tAmt.textContent = formatMoneyEUR(base + ex);
        if (buyLabel) buyLabel.textContent = cta || '';
        if (tr2) tr2.textContent = tr || '';

        document.dispatchEvent(new CustomEvent('bioshots:buybox-updated', {
          detail: { mode, freq, total: formatMoneyEUR(base + ex) }
        }));
      }

      // ---- CHECKOUT ----
      qs(container, '#bs-buy').addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        const { planType, cadence } = planTypeCadence();
        const extras = { glass: extra.glass, scoop: extra.scoop };
        await handleCheckoutWithGifts(sectionEl, planType, cadence, this, extras);
      });

      // ---- THEMA KOOPKNOP INTERCEPT (identiek aan v5.4) ----
      const targetForm = (forms || []).find(f => sectionEl && sectionEl.contains(f)) || forms[0];
      if (targetForm && !targetForm.dataset.cartIntegrationAdded) {
        targetForm.dataset.cartIntegrationAdded = 'true';
        const buyButton = document.querySelector('x-buy-button, .x-product-buy-button, button[name="add"]');
        if (buyButton) {
          buyButton.addEventListener('click', async function(e) {
            e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
            const { planType, cadence } = planTypeCadence();
            const extras = { glass: extra.glass, scoop: extra.scoop };
            await handleCheckoutWithGifts(sectionEl, planType, cadence, buyButton, extras);
          }, true);
        }
      }

      // ---- API VOOR STICKY ----
      window.bsBuyboxApi = {
        setMode: setMode,
        setFreq: setFreq,
        getState: () => ({ mode, freq }),
        getTotal: () => { const el = qs(container, '#bs-t-amt'); return el ? el.textContent : ''; },
        checkout: () => qs(container, '#bs-buy').click()
      };

      // ---- INIT (start: eenmalig geselecteerd, zoals design) ----
      qs(container, '#bs-o-once').classList.add('on');
      qs(container, '#bs-e-once').classList.add('open');
      syncForm();

      if (variantInput) {
        variantInput.addEventListener('change', () => setTimeout(render, 200));
      }

      // extra render zodra radios geladen zijn
      setTimeout(render, 600);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBuybox);
  } else {
    initBuybox();
  }

  // Reset laadstatus van knoppen als de pagina uit de back-forward cache komt
  window.addEventListener('pageshow', function(e) {
    if (!e.persisted) return;
    qsa(document, '.bs-buy, #bs-sticky-btn').forEach(btn => {
      btn.disabled = false;
      const label = btn.querySelector('.bs-buy-label, .bs-sticky__btn-label');
      const spin  = btn.querySelector('.bs-buy-loading, .bs-sticky__btn-loading');
      if (label) label.style.display = '';
      if (spin)  spin.style.display = 'none';
    });
  });
})();